<script setup lang="ts">
import images from "@/assets/js/images";
import type { IAuthParams } from "@/assets/js/types";
import router from "@/router";
import { useApiStore } from "@/store/api";

const apiStore = useApiStore();

const loginParams = ref<IAuthParams>({
	email: "",
	password: "",
});

const handleLogin = async () => {
	const result = await apiStore.callLogin(loginParams.value);
	if (result === 3) {
		console.log(result);

		void router.replace({ name: "TechnicianViewPageVue" });
		return;
	}
	if (result) {
		void router.replace({ name: "HomePage" });
	}
};
</script>
<template>
	<div class="login-wrap">
		<div class="login-modal">
			<div class="head-logo">
				<img src="@/assets/image/vizim-logo-svg.svg" alt="" />
			</div>
			<div class="login-title">Prijava</div>
			<div class="inputs-wrap">
				<CustomInput
					type="text"
					label="Email"
					placeholder="Email"
					:input-value="loginParams.email"
					@input="loginParams.email = $event.target.value"
				/>
				<CustomInput
					type="password"
					label="Lozinka"
					placeholder="Lozinka"
					:input-value="loginParams.password"
					@input="loginParams.password = $event.target.value"
					@keyup.enter="handleLogin"
				/>
			</div>
			<div class="forgor-wrap">
				<router-link to="/auth/forgot-password">
					Zaboravljena lozinka?
				</router-link>
			</div>
			<div class="btn-wrap">
				<CustomButton
					text="Prijavi se"
					:icon="images.loginImg"
					@btn-click="handleLogin"
				/>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.login-wrap {
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background:
		no-repeat url("@/assets/image/login-bg.png"),
		lightgray 50%;
	background-size: cover;

	.login-modal {
		height: 580px;
		width: 380px;
		background: #fff;
		border-radius: 10px;
		box-shadow: 0 0 40px 0 rgb(118 148 255 / 5%);
		padding: 70px 50px;
		display: flex;
		flex-direction: column;

		// justify-content: center;
		align-items: center;

		.head-logo {
			width: 140px;

			img {
				width: 100%;
			}
		}

		.login-title {
			color: $primary-text;
			font-size: 18px;
			font-weight: 600;
			margin: 40px 0;
		}

		.inputs-wrap {
			width: 100%;

			&:deep(.input-wrapper) {
				margin-bottom: 10px;
			}
		}

		.forgor-wrap {
			width: 100%;
			text-align: right;
			margin-bottom: 40px;

			a {
				color: $secondary-text;
				font-size: 12px;
				font-style: italic;
				font-weight: 400;
				line-height: 20px; /* 166.667% */
				text-decoration: none;
			}
		}
	}
}
</style>
